export const menuItems = [
  {
    value: "beginsWith",
  },
  {
    value: "contains",
  },
  {
    value: "isEqual",
  },
];
